module.exports = __webpack_public_path__ + "img/paytype-center-hen.97db6e9f.png";